module.exports = __webpack_public_path__ + "img/btn_arrow.5a7585ed.svg";